import React from 'react';
import download from 'downloadjs';
import Icon from 'shared/components/Icon';

export type DescriptionProps = {
  description: string;
  fetchInvoice: any;
  invoiceId: string;
  subscriberName: string;
};

export function Description(props: DescriptionProps) {
  const { invoiceId, description, fetchInvoice, subscriberName } = props;

  const handleInvoiceDownload = async (description: any, invoiceId: any) => {
    const { payload } = await fetchInvoice(invoiceId);
    const fileName = `${description} - ${subscriberName}.pdf`;

    download(payload, fileName, 'application/pdf');
  };

  return (
    <>
      {invoiceId && (
        <span>
          <a
            className="invoice"
            href="/"
            onClick={e => {
              e.preventDefault();
              handleInvoiceDownload(description, invoiceId);
            }}
          >
            <Icon icon="save_alt" /> {description}
          </a>
        </span>
      )}
      {!invoiceId && description}
    </>
  );
}
